import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.audits.applog.data = {
      ...state.developer.audits.applog.data,
      ...data,
    };
  });
};

const info = async (store, id) => {
  store.setState((state) => {
    state.developer.audits.applog.busy = true;
  });

  try {
    const data = { ...store.state.developer.audits.applog.data };

    const response = await Http.get(`/app/audits/app-logs/${id}`, data);

    store.setState((state) => {
      state.developer.audits.applog.busy = false;
      state.developer.audits.applog.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.audits.applog.busy = false;
      state.developer.audits.applog.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.audits.applog = { ...initialState };
  });
};

const AppLogInfoStore = {
  state: () => initialState,
  actions: {
    change,
    info,
    reset,
  },
};

export default AppLogInfoStore;
